import type { Query } from "react-query";

export const isSignalsQuery = (query: Query): boolean => {
  const { queryKey } = query;
  return (
    Array.isArray(queryKey) &&
    queryKey[0] === "docs" &&
    queryKey[1] === "searchSignals"
  );
};
